import { useEffect, useState } from 'react'
import { getPasswordPolicy } from '@/services/passwordPolicyService'
import { DEFAULT_PASSWORD_POLICY, type PasswordPolicy } from '@/utils/validation'

/**
 * The password rules in force, for any form that asks for a new password.
 *
 * Starts at the defaults so the form validates from the first keystroke, then
 * swaps in the server's policy once it arrives.
 */
export function usePasswordPolicy(): PasswordPolicy {
  const [policy, setPolicy] = useState<PasswordPolicy>(DEFAULT_PASSWORD_POLICY)

  useEffect(() => {
    let active = true
    getPasswordPolicy().then(fetched => {
      if (active) setPolicy(fetched)
    })
    return () => {
      active = false
    }
  }, [])

  return policy
}
